/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Text } from '../../atoms/Text';
import { IBadgeLight, Ibadge } from '../../atoms/AgroIcon/icons';
import { AgroImg } from '../../atoms/AgroImg/AgroImg';
var AgroReducedFooter = function AgroReducedFooter(_ref) {
  var _footerData$location;
  var footerData = _ref.footerData,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'es-AR' : _ref$language,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? 'default' : _ref$background;
  var buildLinksLegals = function buildLinksLegals() {
    var links = [];
    footerData.legals.items.forEach(function (item, idx) {
      links.push(/*#__PURE__*/React.createElement(LegalsLink, {
        target: "_blank",
        rel: "noreferrer",
        href: item.href,
        key: idx,
        variant: variant,
        background: background
      }, /*#__PURE__*/React.createElement(Text, {
        type: "label-sm"
      }, item.label)));
    });
    return links;
  };
  var buildLocation = function buildLocation() {
    var links = [];
    footerData.location.items.forEach(function (item, idx) {
      links.push(/*#__PURE__*/React.createElement(LocationText, {
        background: background
      }, /*#__PURE__*/React.createElement(Text, {
        type: "body-sm",
        weight: "500"
      }, item.label)));
    });
    return links;
  };
  return /*#__PURE__*/React.createElement(ReducedFooter, {
    background: background,
    language: language
  }, /*#__PURE__*/React.createElement(ContainerFooter, null, footerData.location && (_footerData$location = footerData.location) !== null && _footerData$location !== void 0 && _footerData$location.show ? /*#__PURE__*/React.createElement(LocationContainer, {
    variant: variant
  }, buildLocation(), /*#__PURE__*/React.createElement(Separate, null, /*#__PURE__*/React.createElement(StyledLineSeparator, {
    background: background
  }))) : null, /*#__PURE__*/React.createElement(BoxLinkLegals, {
    variant: variant,
    location: footerData.location ? footerData.location : null
  }, /*#__PURE__*/React.createElement(LegalsBox, {
    variant: variant,
    background: background
  }, ' ', buildLinksLegals()), /*#__PURE__*/React.createElement(ContainerTablet, {
    variant: variant,
    background: background
  }, /*#__PURE__*/React.createElement(CopyrightContainer, {
    background: background,
    type: "body-sm",
    color: background === 'light' ? 'black' : 'gray600',
    language: language
  }, /*#__PURE__*/React.createElement(StyledCopyrightText, {
    type: "label-sm"
  }, "\xAE Agrofy ".concat(new Date().getFullYear(), " - ").concat(footerData.general.copyright, "."))), /*#__PURE__*/React.createElement(ContainerIcons, {
    variant: variant,
    background: background
  }, footerData.general && footerData.general.secure.show ? background === 'light' ? /*#__PURE__*/React.createElement(IBadgeLight, null) : /*#__PURE__*/React.createElement(Ibadge, null) : null, footerData.general && footerData.general.afip.show ? /*#__PURE__*/React.createElement(AfipImg, {
    id: "afip",
    href: footerData.general.afip.href,
    rel: "noreferrer nofollow",
    target: "_blank",
    secure: footerData.general.secure.show,
    lpdp: footerData.general.lpdp.show
  }, /*#__PURE__*/React.createElement(AgroImg, {
    imgname: "afip",
    alt: "data-fiscal",
    width: "34,9px",
    height: "48px",
    title: "afip"
  })) : null, footerData.general && footerData.general.lpdp.show ? /*#__PURE__*/React.createElement(LpdpImg, {
    id: "lpdp",
    href: footerData.general.lpdp.href,
    rel: "noreferrer nofollow",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(AgroImg, {
    imgname: "lpdp",
    alt: "lpdp",
    width: "37,5px",
    height: "48px"
  })) : null)))));
};
AgroReducedFooter.propTypes = {
  footerData: PropTypes.object,
  variant: PropTypes.oneOf(['default', 'reduced']),
  background: PropTypes.oneOf(['default', 'light']),
  language: PropTypes.oneOf(['es-AR', 'es-BO', 'es-CL', 'es-CO', 'es-PY', 'es-PE', 'es-UY', 'pt-BR'])
};
export { AgroReducedFooter };
var StyledLineSeparator = styled.div.withConfig({
  displayName: "AgroReducedFooter__StyledLineSeparator",
  componentId: "sc-1kersz9-0"
})(["border-top:1px solid ", ";"], function (_ref2) {
  var theme = _ref2.theme,
    background = _ref2.background;
  return background === 'light' ? theme.colors.gray400 : theme.colors.gray900;
});
var ReducedFooter = styled.div.withConfig({
  displayName: "AgroReducedFooter__ReducedFooter",
  componentId: "sc-1kersz9-1"
})(["display:flex;justify-content:center;", " align-items:space-between;padding:24px;flex-wrap:wrap;background-color:", ";-webkit-text-fill-color:", ";", ""], function (_ref3) {
  var background = _ref3.background,
    theme = _ref3.theme;
  return background === 'light' && css(["border-top:1px ", " solid;"], theme.colors.gray500);
}, function (_ref4) {
  var theme = _ref4.theme,
    background = _ref4.background;
  return background === 'light' ? theme.colors.gray300 : theme.colors.black;
}, function (_ref5) {
  var theme = _ref5.theme,
    background = _ref5.background;
  return background === 'light' ? theme.colors.gray900 : theme.colors.gray600;
}, function (_ref6) {
  var theme = _ref6.theme;
  return css(["@media (min-width:", "){padding:24px 32px;}@media (min-width:", "){padding:", ";display:flex;justify-content:center;}"], theme.breakpoint.md, theme.breakpoint.xl, function (_ref7) {
    var language = _ref7.language;
    return ['es-AR'].includes(language) ? '16px 107px' : '24px 107px';
  });
});
var ContainerFooter = styled.div.withConfig({
  displayName: "AgroReducedFooter__ContainerFooter",
  componentId: "sc-1kersz9-2"
})(["max-width:1200px;width:100%;display:flex;flex-direction:column;@media (min-width:", "){justify-content:center;}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoint.xl;
});
var BoxLinkLegals = styled.div.withConfig({
  displayName: "AgroReducedFooter__BoxLinkLegals",
  componentId: "sc-1kersz9-3"
})(["display:flex;align-items:center;flex-direction:column;width:100%;@media (min-width:", "){", "}@media (min-width:", "){flex-direction:row;justify-content:space-between;align-items:baseline;}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoint.md;
}, function (_ref0) {
  var variant = _ref0.variant;
  return variant === 'default' && css(["justify-content:flex-start;"]);
}, function (_ref1) {
  var theme = _ref1.theme;
  return theme.breakpoint.xl;
});
var LegalsBox = styled.div.withConfig({
  displayName: "AgroReducedFooter__LegalsBox",
  componentId: "sc-1kersz9-4"
})(["display:flex;padding-right:inital;flex-wrap:wrap;flex-direction:column;width:100%;justify-content:center;", ""], function (_ref10) {
  var theme = _ref10.theme;
  return css(["@media (min-width:", "){flex-direction:row;", ";}@media (min-width:", "){justify-content:flex-start;min-width:fit-content;}"], theme.breakpoint.md, function (_ref11) {
    var variant = _ref11.variant;
    return variant === 'default' && css(["justify-content:", ";"], function (_ref12) {
      var background = _ref12.background;
      return background === 'default' ? 'flex-start' : 'center';
    });
  }, theme.breakpoint.xl);
});
var LegalsLink = styled.a.withConfig({
  displayName: "AgroReducedFooter__LegalsLink",
  componentId: "sc-1kersz9-5"
})(["all:unset;cursor:pointer;text-align:center;margin-bottom:8px;@media (min-width:", "){margin-bottom:23px;margin-right:24px;}@media (min-width:", "){margin-bottom:0px;}&:last-child{margin-right:0px;}> span{color:", ";-webkit-text-fill-color:", ";}&:hover{opacity:0.8;}"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.breakpoint.md;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.breakpoint.xl;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.white;
}, function (_ref16) {
  var theme = _ref16.theme,
    background = _ref16.background;
  return background == 'default' ? theme.colors.white : theme.colors.gray900;
});
var ContainerIcons = styled.div.withConfig({
  displayName: "AgroReducedFooter__ContainerIcons",
  componentId: "sc-1kersz9-6"
})(["display:flex;margin-top:16px;justify-content:center;align-items:center;width:", ";@media (min-width:", "){flex-direction:row;margin-top:0px;justify-content:", ";}@media (max-width:", "){width:100%;}"], function (_ref17) {
  var background = _ref17.background;
  return background === 'default' ? '100%' : 'max-content';
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.breakpoint.md;
}, function (_ref19) {
  var background = _ref19.background;
  return background === 'default' ? 'flex-end' : 'center';
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.breakpoint.md;
});
var AfipImg = styled.a.withConfig({
  displayName: "AgroReducedFooter__AfipImg",
  componentId: "sc-1kersz9-7"
})(["position:initial;", " ", " img{display:inherit;}"], function (_ref21) {
  var secure = _ref21.secure,
    theme = _ref21.theme;
  return secure && css(["margin-left:16px;@media (min-width:", "){margin-left:24px;}"], theme.breakpoint.md);
}, function (_ref22) {
  var lpdp = _ref22.lpdp,
    theme = _ref22.theme;
  return lpdp && css(["margin-right:16px;"]);
});
var LpdpImg = styled.a.withConfig({
  displayName: "AgroReducedFooter__LpdpImg",
  componentId: "sc-1kersz9-8"
})(["position:initial;img{display:inherit;}"]);
var StyledCopyrightText = styled(Text).withConfig({
  displayName: "AgroReducedFooter__StyledCopyrightText",
  componentId: "sc-1kersz9-9"
})(["text-align:center;align-items:center;display:flex;"]);
var CopyrightContainer = styled(Text).withConfig({
  displayName: "AgroReducedFooter__CopyrightContainer",
  componentId: "sc-1kersz9-10"
})(["color:", ";-webkit-text-fill-color:", ";@media (min-width:", "){flex-direction:row;align-self:center;min-width:max-content;", ";}@media (max-width:", "){text-align:center;justify-content:center;}"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.gray900;
}, function (_ref24) {
  var background = _ref24.background,
    theme = _ref24.theme;
  return background === 'default' ? theme.colors.gray200 : theme.colors.black;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.breakpoint.md;
}, function (_ref26) {
  var language = _ref26.language;
  return (language === 'es-AR' || language === 'pt-BR') && css(["margin-right:24px;"]);
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.breakpoint.md;
});
var LocationContainer = styled.div.withConfig({
  displayName: "AgroReducedFooter__LocationContainer",
  componentId: "sc-1kersz9-11"
})(["display:flex;flex-wrap:wrap;flex-direction:column;width:100%;@media (min-width:", "){justify-content:center;flex-direction:row;", "}@media (min-width:", "){justify-content:space-between;flex-direction:row;}"], function (_ref28) {
  var theme = _ref28.theme;
  return theme.breakpoint.md;
}, function (_ref29) {
  var variant = _ref29.variant;
  return variant === 'default' && css(["justify-content:", ";"], function (_ref30) {
    var background = _ref30.background;
    return background === 'default' ? 'flex-start' : 'center';
  });
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.breakpoint.xl;
});
var LocationText = styled.a.withConfig({
  displayName: "AgroReducedFooter__LocationText",
  componentId: "sc-1kersz9-12"
})(["all:unset;margin:0;padding:0;justify-content:center;text-align:center;margin-bottom:8px;margin-right:16px;&:nth-last-child(2){margin-right:0px;}> span{color:", ";-webkit-text-fill-color:", ";}"], function (_ref32) {
  var theme = _ref32.theme,
    background = _ref32.background;
  return background === 'default' ? theme.colors.gray600 : theme.colors.gray900;
}, function (_ref33) {
  var theme = _ref33.theme,
    background = _ref33.background;
  return background === 'default' ? theme.colors.gray600 : theme.colors.gray900;
});
var Separate = styled.div.withConfig({
  displayName: "AgroReducedFooter__Separate",
  componentId: "sc-1kersz9-13"
})(["margin-top:12px;margin-bottom:12px;width:100%;@media (max-width:767px){margin-top:16px;margin-bottom:16px;}"]);
var ContainerTablet = styled.div.withConfig({
  displayName: "AgroReducedFooter__ContainerTablet",
  componentId: "sc-1kersz9-14"
})(["@media (min-width:", "){flex-direction:row;display:flex;", "}@media (max-width:", "){margin-top:8px;}@media (min-width:", "){justify-content:flex-end;width:fit-content;}"], function (_ref34) {
  var theme = _ref34.theme;
  return theme.breakpoint.md;
}, function (_ref35) {
  var variant = _ref35.variant;
  return variant === 'default' && css(["width:100%;justify-content:", ";"], function (_ref36) {
    var background = _ref36.background;
    return background === 'default' ? 'space-between' : 'center';
  });
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.breakpoint.md;
}, function (_ref38) {
  var theme = _ref38.theme;
  return theme.breakpoint.xl;
});